// components/screens/PaymentSuccessScreen.tsx
import React, { useEffect } from "react";
import { View, Text, StyleSheet } from "react-native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";

interface Props {
  navigation: NativeStackNavigationProp<RootStackParamList, "PaymentSuccess">;
}

export default function PaymentSuccessScreen({ navigation }: Props) {
  useEffect(() => {
    const timer = setTimeout(() => {
      navigation.replace("Profile");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigation]);

  return (
    <View style={styles.container}>
      <Text style={styles.checkmark}>✓</Text>
      <Text style={styles.title}>Payment Successful!</Text>
      <Text style={styles.subtitle}>Redirecting to your profile...</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#112345",
    justifyContent: "center",
    alignItems: "center",
  },
  checkmark: {
    fontSize: 72,
    color: "#00f0ff",
    marginBottom: 20,
  },
  title: {
    fontSize: 28,
    color: "#fff",
    fontWeight: "bold",
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 16,
    color: "#aaa",
  },
});